import { pickIndexSectionBackgroundProps } from '@/components/page-sections/index-section-utils';
import { readString } from '@/lib/prop-utils';
import type { BlogIndexProps } from './definition';

export function readBlogIndexProps(props: BlogIndexProps) {
  const rawProps = props as Record<string, unknown>;
  const pinnedHeading = readString(props.pinnedHeading);
  const pinnedDescription = readString(props.pinnedDescription);

  return {
    ...props,
    pinnedHeading: pinnedHeading ?? '',
    pinnedDescription: pinnedDescription ?? '',
    showFilters: props.showFilters ?? true,
    backgroundProps: pickIndexSectionBackgroundProps(rawProps),
  };
}
